import React, { ReactElement, useState } from 'react';
import ReactDOM from 'react-dom';
import { GOOGLE_DEVELOPER_KEY } from '../../utils/constants';

const SeeLocation: React.FC<any> = (data: any): ReactElement => {
    const { seller } = data;
    const [isOpened, setIsOpened] = useState(false);

    const center = [
        Number(seller.latitude),
        Number(seller.longitude),
    ];

    const generateLinkUrl = (latLon: Array<number> = [41.0, -77.5]) => {
        const blurredLocation = `${latLon[0].toFixed(1)},${latLon[1].toFixed(1)}`;
        return `https://www.google.com/maps/search/?api=1&query=${blurredLocation}`;
    };

    const generateMapUrl = (latLon: Array<number> = [41.0, -77.5]) => {
        const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap?';
        const blurredLocation = `${latLon[0].toFixed(1)},${latLon[1].toFixed(1)}`;
        const markerQueryParams = [
            'color:0x3e5c76',
            blurredLocation, // Note: location goes *after* color
        ];
        const staticMapQueryParams = [
            `center=${blurredLocation}`,
            `key=${GOOGLE_DEVELOPER_KEY}`,
            `markers=${markerQueryParams.join('%7C')}`,
            'size=600x350',
            'zoom=10',
        ];
        return baseUrl + staticMapQueryParams.join('&');
    };

    const VisualizeLocation = () => {
        // if seller location photo is available show both photo and map
        if (seller.locationPhoto) {
            return (
                <div className="seller-location-photo-and-map">
                    <a
                        href={generateLinkUrl(center)}
                        target="_blank"
                        className="seller-location-map"
                        rel="noreferrer"
                    >
                        <img
                            src={generateMapUrl(center)}
                            alt="Map showing seller's approximate location"
                            className="seller-location-photo img-fluid"
                            title="Seller's Approximate Location"
                        />
                    </a>
                    <img
                        className="seller-location-photo"
                        src={seller.locationPhoto}
                        alt="Sellers location"
                    />
                </div>
            );
        }
        // if seller location photo is not available show only map
        return (
            // link image to google maps
            <a
                href={generateLinkUrl(center)}
                target="_blank"
                className="seller-location-map"
                rel="noreferrer"
            >
                <img
                    src={generateMapUrl(center)}
                    alt="Map showing seller's approximate location"
                    className="seller-location-photo img-fluid"
                    title="Seller's Approximate Location"
                />
            </a>
        );
    };

    function toggle() {
        setIsOpened((wasOpened) => !wasOpened);
    }

    return (
        <div className="col-xs-12">
            <button className="btn btn-block see-location-btn mt-2 border border-solid" onClick={toggle}>
                {!isOpened ? (
                    <>
                        See Location
                        <i className="fa fa-angle-down ml-2" />
                    </>
                ) : (
                    <>
                        Hide Location
                        <i className="fa fa-angle-up ml-2" />
                    </>
                )}
            </button>
            {isOpened && (
                <VisualizeLocation />
            )}
        </div>
    );
};

if (document.getElementsByClassName('react-see-location').length > 0) {
    document.querySelectorAll('.react-see-location')
        .forEach((element) => {
            const seller = JSON.parse(element.getAttribute('data-seller') ?? '');
            ReactDOM.render(<SeeLocation seller={seller} />, element);
        });
}

export default SeeLocation;
